import React from "react";
import {
  Box,
  Text,
  Flex,
  Modal,
  Button,
  Divider,
  ModalBody,
  ModalOverlay,
  ModalContent,
} from "@chakra-ui/react";

import DataBox from "components/databox";
import TextAreaDataBox from "components/textAreaDataBox.js";

const ViewModal = ({ isOpen, onClose, size = "xl", data }) => {
  const websiteLink = data?.shopify_url || "";
  return (
    <Modal isOpen={isOpen} onClose={onClose} size={size}>
      <ModalOverlay />
      <ModalContent maxWidth={"800px"} borderRadius={"16px"} p={4}>
        <ModalBody gap={6} display={"flex"} flexDirection={"column"}>
          <Text
            fontSize={"24px"}
            fontFamily={"PlusJakartaSansSemiBold"}
            color={"#000000"}
          >
            View Product
          </Text>
          <Divider borderWidth={"1px"} width={"100%"} color={"#8A8F9333"} />
          <Box>
            <Text
              fontWeight={"600"}
              fontSize={"16px"}
              fontFamily={"PlusJakartaSansSemiBold"}
              color={"#000000"}
              pb={4}
            >
              General Details
            </Text>
            <Box
              // height={"276px"}
              borderRadius={"6px"}
              padding={"16px"}
              border={"1px solid #D9D9D9"}
            >
              <Flex gap={5}>
                <DataBox
                  label={"SKU"}
                  data={data?.variants?.sku}
                  containerStyles={{
                    minHeight: "48px",
                  }}
                />
                <DataBox
                  label={"Product Title"}
                  data={data?.product_title}
                  containerStyles={{
                    minHeight: "48px",
                  }}
                />
              </Flex>
              <Flex gap={5} pt={"10px"}>
                {/* <FormikSelect label={"Location"} placeholder={"Select one.."} /> */}
                <DataBox
                  label={"Location"}
                  data={data?.variants?.instances?.location?.name}
                  containerStyles={{
                    minHeight: "48px",
                  }}
                />
                {data?.variants?.instances?.status === "shopify" && (
                  <Box flex={1}>
                    <Text
                      color={"#000000"}
                      fontFamily={"PlusJakartaSansMedium"}
                      fontSize={"12px"}
                      marginBottom={2}
                    >
                      Website Link
                    </Text>
                    <Box
                      padding={"12px"}
                      borderWidth={1}
                      borderRadius={"4px"}
                      borderColor={"#D9D9D9"}
                      borderStyle={"solid"}
                      backgroundColor={"#FFFFFF"}
                      height={"48px"}
                      overflowX={"auto"}
                      overflowY={"hidden"}
                      whiteSpace={"nowrap"}
                      cursor={websiteLink ? "pointer" : "default"}
                      onClick={() => {
                        if (websiteLink) {
                          window.open(websiteLink, "_blank");
                        }
                      }}
                      _hover={websiteLink ? { borderColor: "#3182CE" } : {}}
                      sx={{
                        "&::-webkit-scrollbar": {
                          height: "4px",
                        },
                        "&::-webkit-scrollbar-track": {
                          background: "#f1f1f1",
                        },
                        "&::-webkit-scrollbar-thumb": {
                          background: "#c1c1c1",
                          borderRadius: "2px",
                        },
                      }}
                    >
                      <Text
                        color={websiteLink ? "#3182CE" : "#898989"}
                        fontFamily={"PlusJakartaSansRegular"}
                        fontSize={"12px"}
                        _hover={websiteLink ? { textDecoration: "underline" } : {}}
                      >
                        {websiteLink || "-"}
                      </Text>
                    </Box>
                  </Box>
                )}
              </Flex>
              <Flex gap={5} pt={"10px"} mb={"10px"}>
                <DataBox
                  label={"Status"}
                  data={data?.variants?.instances?.status}
                  containerStyles={{
                    minHeight: "48px",
                  }}
                />
              </Flex>
              {data?.variants?.instances?.status === "rejected" ? (
                <Flex gap={5} pt={"10px"} mb={"10px"}>
                  <TextAreaDataBox
                    label={"Rejection Reason"}
                    data={data?.variants?.instances?.rejection_reason}
                    containerStyles={{
                      minHeight: "48px",
                    }}
                  />
                </Flex>
              ) : (
                <Flex gap={5} pt={"10px"} mb={"10px"}>
                  <TextAreaDataBox
                    label={"Notes"}
                    data={data?.variants?.instances?.note}
                    containerStyles={{
                      minHeight: "48px",
                    }}
                  />
                </Flex>
              )}
            </Box>
          </Box>
          <Flex justifyContent={"flex-end"} gap={3}>
            <Button
              onClick={onClose}
              width={"174px"}
              height={"40px"}
              borderRadius={"12px"}
              bg={"none"}
              border={"1px solid #000000"}
              color={"#000000"}
              fontSize={"12px"}
              fontWeight={"500"}
              fontFamily={"PlusJakartaSansMedium"}
              letterSpacing={0.2}
            >
              CLOSE
            </Button>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ViewModal;
